import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "ontos-view-tabs-measure",
  "aria-hidden": "true",
  inert: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "wrap",
    class: _normalizeClass(["ontos-view-tabs-box", {'ontos-view-tabs-box--overflow': _ctx.overflow}])
  }, [
    _createVNode(_component_v_tabs, {
      "model-value": _ctx.modelValue,
      color: "primary",
      density: "compact",
      class: "ontos-view-tabs",
      stacked: _ctx.stacked,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = () => undefined)
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shown, (view) => {
          return (_openBlock(), _createBlock(_component_v_tab, {
            key: view.value,
            value: view.value,
            to: view.to,
            class: "shell-plain-case",
            title: _ctx.compact ? view.title : undefined,
            onClick: ($event: any) => (_ctx.pick(view))
          }, {
            default: _withCtx(() => [
              (view.icon)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    start: !_ctx.compact && !_ctx.stacked,
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(view.icon), 1)
                    ]),
                    _: 2
                  }, 1032, ["start"]))
                : _createCommentVNode("", true),
              (!_ctx.compact)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(view.title), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (view.alert)
                ? (_openBlock(), _createBlock(_component_v_badge, {
                    key: 2,
                    color: "error",
                    dot: "",
                    inline: ""
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["value", "to", "title", "onClick"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["model-value", "stacked"]),
    (_ctx.folded.length)
      ? (_openBlock(), _createBlock(_component_v_menu, {
          key: 0,
          location: "bottom end"
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps(props, {
              variant: "text",
              size: "small",
              class: "shell-plain-case",
              "append-icon": "mdi-chevron-down"
            }), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$tt('more')), 1)
              ]),
              _: 1
            }, 16)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list, { density: "compact" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folded, (view) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    key: view.value,
                    title: view.title,
                    to: view.to,
                    "prepend-icon": view.icon,
                    onClick: ($event: any) => (_ctx.pick(view))
                  }, null, 8, ["title", "to", "prepend-icon", "onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.overflow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_tabs, {
            density: "compact",
            class: "ontos-view-tabs",
            stacked: _ctx.stacked
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.views, (view, index) => {
                return (_openBlock(), _createBlock(_component_v_tab, {
                  key: view.value,
                  class: "shell-plain-case",
                  ref_for: true,
                  ref: (tab) => _ctx.fit.measure(index, tab?.$el)
                }, {
                  default: _withCtx(() => [
                    (view.icon)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          start: !_ctx.compact && !_ctx.stacked,
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(view.icon), 1)
                          ]),
                          _: 2
                        }, 1032, ["start"]))
                      : _createCommentVNode("", true),
                    (!_ctx.compact)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(view.title), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["stacked"]),
          _createVNode(_component_v_btn, {
            ref: (button) => _ctx.measureMore(button?.$el),
            variant: "text",
            size: "small",
            class: "shell-plain-case",
            "append-icon": "mdi-chevron-down"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$tt('more')), 1)
            ]),
            _: 1
          }, 512)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}